import React from "react";
import Auxiliary from "../../Components/HOC/Auxiliary";
import SearchResultsHeader from "../../Components/SearchResultsHeader/SearchResultsHeader";
import {connect} from "react-redux";
import Footer from "../../Components/Footer/Footer";

const SearchResultsImages =(props)=>{
    const {data} = props;
    // console.log(data.items);
    return(
        <Auxiliary>
            <SearchResultsHeader />
            <div className="result_images_container">
                {
                    data?.items?.map((item, i) =>{
                        return(
                            <a key={item?.cacheId ?  item?.cacheId : "#" + i} href={item.link}><img  src={ item?.pagemap?.cse_thumbnail ? item?.pagemap?.cse_thumbnail[0]?.src  : item?.pagemap?.cse_image ? item?.pagemap?.cse_image[0]?.src : ""} alt={item.title} /> </a>
                            )
                    })
                }
            </div>
            <Footer />
        </Auxiliary>
    )
}
{/* <img  src={item?.pagemap?.cse_thumbnail?.src} alt={item.title} /> */}
const mapStateToProps= state=>{
    return{
        data: state.receivedData
    }
}
export default connect(mapStateToProps) (SearchResultsImages);